import React, { useState } from "react";
import { AlertCircle } from "lucide-react";
import { showToast } from "../../../../../Helper/Toast";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AppVersion = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  

  return (
    <>
      <div className="delete-account-container">
        <h1 className="page-title">App Version</h1>

        <div className="warning-card">
         
          <p className="warning-description">
            App Version- 1.0.0
          </p>        

         
        </div>
      </div>
    </>
  );
};

export default AppVersion;
